import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './components/app/app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { MAT_DATE_LOCALE, MatRipple } from '@angular/material/core';
import { ContainerComponent } from './components/container/container.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';
import { DialogRoomDetailComponent } from './components/dialog-room-detail/dialog-room-detail.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SnackbarCustomComponent } from './components/snackbar-custom/snackbar-custom.component';
import { DialogPaymentSuccessComponent } from './components/dialog-payment-success/dialog-payment-success.component';
import { DialogFirstMonthRentalFeeComponent } from './components/dialog-first-month-rental-fee/dialog-first-month-rental-fee.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { ResetPasswordDialogComponent } from './components/reset-password-dialog/reset-password-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UrlFileModule } from './shares/file/urlFile.module';
import { DateModule } from './shares/date/date.module';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { BrowserModule, REMOVE_STYLES_ON_COMPONENT_DESTROY } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatBadgeModule } from '@angular/material/badge';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { NoFileComponent } from './shares/no-file/no-file.component';
import { FileItemComponent } from './shares/file-item/file-item.component';
import { CheckExpiringStatusComponent } from './shares/check-expiring-status/check-expiring-status.component';
import { AuthorizedPermissionDirective } from './directives/authorized-permission.directive';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    ContainerComponent,
    DialogRoomDetailComponent,
    SnackbarCustomComponent,
    DialogPaymentSuccessComponent,
    DialogFirstMonthRentalFeeComponent,
    ResetPasswordDialogComponent,
  ],
  imports: [
    CheckExpiringStatusComponent,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NoFileComponent,
    FileItemComponent,
    HttpClientModule,
    MatSnackBarModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    MatSelectModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatDialogModule,
    MatDividerModule,
    MatGridListModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatTooltipModule,
    UrlFileModule,
    DateModule,
    MatBadgeModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MatRipple,
    AuthorizedPermissionDirective,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    /**
     * Is used for refresh token
     */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    DatePipe,
    CurrencyPipe,
    {
      provide: REMOVE_STYLES_ON_COMPONENT_DESTROY,
      useValue: false,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
